import {toast} from 'sonner'

export const onSubmit = ({
    itemData,
    itemName,
    doSomething,
    setOpenDialog = () => {},
    reset = () => {},
    commandType,
    t,
}) => {
    toast.promise(
        doSomething(itemData)
            .unwrap()
            .then((payload) => {
                setOpenDialog(false)
                reset({})
                return payload
            })
            .catch((error) => {
                throw error
            }),
        {
            loading: t('loading'),
            success: () => {
                return t(`${itemName}s.submit.${commandType}.success`)
            },
            error: (err) => {
                return err?.data?.error || t(`${itemName}s.submit.${commandType}.error`)
            },
        }
    )
}

export const onDelete = (itemData, itemName, doDelete, t) => {
    toast.promise(
        doDelete(itemData)
            .unwrap()
            .then((payload) => {
                return payload
            })
            .catch((error) => {
                throw error
            }),
        {
            loading: t('loading'),
            success: () => {
                return t(`${itemName}s.delete.success`)
            },
            error: (err) => {
                return err?.data?.error || t(`${itemName}s.delete.error`)
            },
        }
    )
}
